interface IMetadataObj {
    [x: string]: any;
}

// Months array for date formatting
const months: Array<string> = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];

const states: string[][] = [
    ["Alabama", "AL"],
    ["Alaska", "AK"],
    ["American Samoa", "AS"],
    ["Arizona", "AZ"],
    ["Arkansas", "AR"],
    ["California", "CA"],
    ["Colorado", "CO"],
    ["Connecticut", "CT"],
    ["Delaware", "DE"],
    ["District of Columbia", "DC"],
    ["Florida", "FL"],
    ["Georgia", "GA"],
    ["Guam", "GU"],
    ["Hawaii", "HI"],
    ["Idaho", "ID"],
    ["Illinois", "IL"],
    ["Indiana", "IN"],
    ["Iowa", "IA"],
    ["Kansas", "KS"],
    ["Kentucky", "KY"],
    ["Louisiana", "LA"],
    ["Maine", "ME"],
    ["Maryland", "MD"],
    ["Massachusetts", "MA"],
    ["Michigan", "MI"],
    ["Minnesota", "MN"],
    ["Mississippi", "MS"],
    ["Missouri", "MO"],
    ["Montana", "MT"],
    ["Nebraska", "NE"],
    ["Nevada", "NV"],
    ["New Hampshire", "NH"],
    ["New Jersey", "NJ"],
    ["New Mexico", "NM"],
    ["New York", "NY"],
    ["North Carolina", "NC"],
    ["North Dakota", "ND"],
    ["Northern Mariana Islands", "MP"],
    ["Ohio", "OH"],
    ["Oklahoma", "OK"],
    ["Oregon", "OR"],
    ["Pennsylvania", "PA"],
    ["Puerto Rico", "PR"],
    ["Rhode Island", "RI"],
    ["South Carolina", "SC"],
    ["South Dakota", "SD"],
    ["Tennessee", "TN"],
    ["Texas", "TX"],
    ["Trust Territories", "TT"],
    ["Utah", "UT"],
    ["Vermont", "VT"],
    ["Virgin Islands", "VI"],
    ["Virginia", "VA"],
    ["Washington", "WA"],
    ["West Virginia", "WV"],
    ["Wisconsin", "WI"],
    ["Wyoming", "WY"],
];

// Character limit for suggestion api
const suggestionApiQueryMaxlength: number = 70;

// Character limit for job search api
const jobSearchQueryMaxlength: number = 128;

// legacy search string keys
// TODO: remove non legeacy fields
const validParamKeys: IMetadataObj = {
    company: "company",
    job_location: "location",
    location: "location",
    job_level: "level",
    keyword: "keyword",
    company_size: "size",
    industry: "industry",
    perks: "perks",
    category: "category",
    work_location: "work_location",
    radius: "radius",
    posted_date_range: "date-posted"
};

const validFilterKeys: IMetadataObj = {
    company: "company",
    location: "location",
    keyword: "keyword",
    experienceLevel: "level",
    companySize: "size",
    industry: "industry",
    perks: "perks",
    category: "category",
    work_location: "work_location",
    radius: "radius",
    postedDateRange: "date-posted",
    companyLeadership: "company-leadership"
};

const legacyJobLevel: IMetadataObj = {
    "entry level": "entry",
    "mid level": "mid",
    "senior level": "senior",
    "management level": "management",
    internship: "internship"
};

const legacyCompanySize: IMetadataObj = {
    "small size": "1_50",
    "medium size": "51_200,201_500",
    "large size": "501_1000,1001_5000,5001_10000,10000_plus",
};

export {
    months,
    jobSearchQueryMaxlength,
    legacyCompanySize,
    legacyJobLevel,
    states,
    suggestionApiQueryMaxlength,
    validParamKeys,
    validFilterKeys
};
